import { createStore, combineReducers } from 'redux'

const initialState = {}

export default createStore(
    combineReducers({
        app: (state = initialState, action) => {
            switch (action.type) {
                case 'CURRENT_USER_SET':
                    return { ...state, currentUser: action.payload }
                case 'CURRENT_USER_PROFILE_SET':
                    return { ...state, currentUserProfile: action.payload }
                case 'CURRENT_LOYALTY_MEMBER_DETAIL_SET':
                    return { ...state, currentLoyaltyMemberDetail: action.payload }
                case 'ACCESS_TOKEN_SET':
                    return { ...state, accessToken: action.payload }

                default:
                    return state
            }
        }
    })
)